const linearPreviewHeight = 120;
const bottomPadding = 45;
const paddingLinearEditor = 20;

export {
    linearPreviewHeight,
    bottomPadding,
    paddingLinearEditor,
}